const initialState = {
  routeData: {
    planned: { stops: [], locations: [] },
    actual: { stops: [], locations: [] },
    isLoading: false,
  },
  runData: {
    runOptions: [],
    defaultValue: null,
    isLoading: false,
  },
  stopsDict: {},
  selectedStopId: null,
  isStopMarkerClicked: false,
  usersLocationInfo: {
    users: [],
    isLoading: false,
  },
  geofenceEvents: {
    isLoading: false,
    items: [],
  },
};

export default initialState;
